"use client";

import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "./Dropdown";

const LANGUAGE_LIST = [
  { name: "KO", value: "ko_KR" },
  { name: "EN", value: "en_US" },
  { name: "JA", value: "ja_JP" },
  { name: "ZH", value: "zh_CN" },
] as const;

const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 30;

const LanguageIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.3335 14.0007C2.3335 20.4442 7.55666 25.6673 14.0002 25.6673C20.4437 25.6673 25.6668 20.4442 25.6668 14.0007C25.6668 7.55715 20.4437 2.33398 14.0002 2.33398C7.55666 2.33398 2.3335 7.55715 2.3335 14.0007Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1667 2.39258C15.1667 2.39258 18.6667 7.00091 18.6667 14.0009C18.6667 21.0009 15.1667 25.6092 15.1667 25.6092M12.8334 25.6092C12.8334 25.6092 9.33336 21.0009 9.33336 14.0009C9.33336 7.00091 12.8334 2.39258 12.8334 2.39258M3.06836 18.0842H24.9317M3.06836 9.91758H24.9317"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LanguageSelector = ({ isTop = false }: { isTop?: boolean }) => {
  const { i18n } = useTranslation();

  const displayValue = useMemo(
    () =>
      LANGUAGE_LIST.find((item) => item.value === i18n.language)?.name || "KO",
    [i18n.language],
  );

  const handleLanguageChange = useCallback(
    (value: string) => {
      document.cookie = `locale=${encodeURIComponent(
        value,
      )}; path=/; max-age=${LOCALE_COOKIE_MAX_AGE}; samesite=lax`;
      i18n.changeLanguage(value);
    },
    [i18n],
  );

  return (
    <Dropdown
      items={LANGUAGE_LIST}
      displayValue={displayValue}
      selectedValue={i18n.language}
      onSelect={handleLanguageChange}
      icon={<LanguageIcon />}
      isTop={isTop}
    />
  );
};

export default LanguageSelector;
